export default {
  standrad: '标准',
  pleaseEnterStandradNameOrCode: '请输入标准名称或代码',
  createNewStandardDatabase: '创建新标准库',
  goToDrawingLists: '跳转绘图列表',
  goToClassManagement: '跳转类别管理',
  goToEntityManagement: '跳转实体管理',
  upgrade: '升版',
  thumbnail: '缩略图',
  upgradeStandard: '升级标准',
  thumbnailsCanOnlyBeInJpgPng: '缩略图只能是 jpg, png格式',
  theSizeUploadAvatarOnlyHalfMb: '上传头像图片大小不能超过 5MB',
  confirmDeleteSelectedStandard: '是否确定要删除所选择的标准',
  createStandard: '新增标准',
  editTheStandard: '修改标准',
  pleaseEnterTheVersion: '请输入版本号',
  working: '工作中',
  released: '已发布',
  standardCode: '标准代码',
  standardName: '标准名称',
  CreateUser: '创建人',
  Class: '实体',
  TheRecommendedSizeIs220Pixels: '建议尺寸为220*170像素',
  TheSizeOfTheUploadedImageCannotExceed5MB: '上传图片大小不能超过5MB',
  publish: '发布',
  unpublished: '未发布',
  storeSettings: '存储设置',
  attributeGrouping: '属性分组',
  attribute: '属性',
  grouping: '分组',
  selectTheGroup: '选择分组',
  readAndQritePermissions: '读写权限',
  APIInputField: 'API输入字段',
  queryDataIsNotDisplayed: '查询数据不显示',
  whetherItIisAtypeOrNot: '是否是类型',
  pleaseSelectABusinessType: '请选择业务类型',
  whetherItIsMasterDataOrNot: '是否主数据',
  pleaseSelectMasterDataType: '请选择主数据类型',
  topic: '主题',
  label: '标签',
  extendedProperties: '扩展属性',
  extendPropertyValue: '扩展属性值',
  pleaseSelectGroupYouWantToEdit: '请选择要编辑的分组',
  entitiesOrDocumentsCannotBeEdited: '实体或者文档不能编辑',
  groupNameCannotBeUngrouped: '分组名称不能为“未分组”',
  selectAttributeGroupYouWantToDelete: '请选择要删除的属性分组',
  entitiesDocumentsCannotBeDeleted: '实体或者文档不能删除',
  deleteAttributeGrouping: '是否确定要删除该属性分组？',
  cannotBeGrouped: '对象或者文档不能进行分组',
  tickData: '请勾选数据',
  setGroupSuccessful: '设置分组成功',
  removeGroupSuccessful: '移除分组成功',
  goToDatasetManagement: '跳转至数据集管理',
}
